import type { FilterConfigBarItemDefault } from '@rocco/ui/filter-sort/types/filter-config-bar';
import type { SingleValueFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/single-value-filter-state';
import type { FilterBarElementProps } from '@rocco/ui/filter-sort/components/filters-bar/FiltersBarElement';
import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { Label as RoccoLabel } from '@rocco/components/label';

export const FiltersBarSingleValue = (
    props: FilterBarElementProps<
        FilterConfigBarItemDefault,
        SingleValueFilterState
    >,
) => {
    const { filterConfigItem, filterState, onFilterStateUpdate } = props;
    const count = filterState.count ?? 0;

    return filterConfigItem.hideWhenEmpty && count < 1 ? null : (
        <div
            className="flex items-center h-8 border-transparent border px-2 rounded-2
        hover:bg-primary-foreground hover:text-primary hover:border- group cursor-pointer"
        >
            <RoccoCheckbox
                id={filterConfigItem.filterKey}
                checked={filterState.checked}
                groupHover="light"
                onCheckedChange={checked => {
                    onFilterStateUpdate(
                        { ...filterState, checked: !!checked },
                        true,
                    );
                }}
            />
            <RoccoLabel htmlFor={filterConfigItem.filterKey} target="checkbox">
                {filterConfigItem.label}
            </RoccoLabel>
        </div>
    );
};
